var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.75581 15.5832C1.38067 15.5832 1.06358 15.4537 0.804557 15.1946C0.545529 14.9356 0.416016 14.6185 0.416016 14.2434V1.7563C0.416016 1.38116 0.545529 1.06407 0.804557 0.805046C1.06358 0.546018 1.38067 0.416504 1.75581 0.416504H8.20768L11.5827 3.7915V7.689C11.3124 7.82567 11.0685 8.00671 10.851 8.23213C10.6337 8.45755 10.4149 8.68032 10.1948 8.90046L6.19477 12.8796V15.5832H1.75581ZM7.85518 15.5832V13.5896L12.15 9.31546C12.2294 9.23935 12.3147 9.18373 12.4058 9.14859C12.4971 9.11359 12.5875 9.09609 12.6771 9.09609C12.7723 9.09609 12.8661 9.11366 12.9583 9.1488C13.0507 9.18407 13.1332 9.23699 13.206 9.30755L14.1227 10.253C14.1928 10.3324 14.2469 10.4178 14.285 10.509C14.3232 10.6001 14.3423 10.6905 14.3423 10.78C14.3423 10.8696 14.3247 10.9607 14.2896 11.0532C14.2546 11.1457 14.1989 11.2309 14.1227 11.309L9.84872 15.5832H7.85518ZM12.6612 11.7355L13.5987 10.785L12.6612 9.83963L11.7237 10.798L12.6612 11.7355ZM7.41602 4.58317H10.4993L7.41602 1.49984V4.58317Z",
    fill: "black",
    fillOpacity: 0.56
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEdit);
export default __webpack_public_path__ + "static/media/icon-edit.c7fb77727e3faffd1123ab5918550674.svg";
export { ForwardRef as ReactComponent };